import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { UserState, ManageUsersState } from '../interface/MyInterfaces';

import { logout } from '../actions/UserActions';
import { sendPasswordResetEmail } from '../actions/ManageUsersActions';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ApplicationState } from '../reducers/Index';

import styled from "styled-components";
import { IrisColors } from '../css/IRISColors';
import { Heading2, IRISBlueDivider } from './Common/SharedStyledComponents';

interface ForgotPasswordState {
    Email?: string;
    EmailSent?: string;
}

interface ForgotPasswordProps {
    sendPasswordResetEmail?(username?: string, firstname?: string, lastname?: string, display_id?: string);
    ManageUsersState?: ManageUsersState
    logout?();
}

class ForgotPassword extends React.Component<ForgotPasswordProps, ForgotPasswordState> {
    constructor(props) {
        super(props);
        this.state = {
            Email: "",
            EmailSent: ""
        }

        this.handleSubmit = this.handleSubmit.bind(this);

        this.handleEmailChange = this.handleEmailChange.bind(this);

    }
    handleSubmit() {

        if (this.state.EmailSent == "email not exists") {
            this.props.logout();
        }
        else {
            if (this.state.Email !== "") {

                this.setState({
                    EmailSent: this.props.ManageUsersState.Message
                });
                this.props.sendPasswordResetEmail(this.state.Email, "", "", "");
            }
        }
    }

    enterPressed(event) {
        var code = event.keyCode || event.which;
        if (code === 13) { //13 is the enter keycode
            this.handleSubmit();
        }
    }

    handleEmailChange(event) {
        this.setState({
            Email: event.target.value
        });
    }

    public render() {

        return <div className="wrapper">
            {this.props.ManageUsersState.Message == "" &&
                <PasswordResetForm className="form-signin form-password form-wider">
                    <Heading2 color={IrisColors.irisLogoBlue} bold center>Forgot your password?</Heading2>
                    <IRISBlueDivider />
                    <p>Don't worry. Resetting your password is easy, just tell us your email address registered with IRIS Member Portal.
                    </p>
                    <div>
                        <label htmlFor="email">Your email address:</label>
                        <input
                            id="email"
                            type="text"
                            className="form-control"
                            name="email"
                            onChange={this.handleEmailChange}
                            value={this.state.Email}
                            placeholder="john@doe.com"
                        />
                    </div>
                    <button className="btn btn-lg btn-primary btn-block" type="button" onClick={() => this.handleSubmit()}>Reset my password!</button>
                </PasswordResetForm>
            }
            {this.props.ManageUsersState.Message == "email not exists" &&
                <div className="form-signin form-password form-wider">
                    <h2 className="form-signin-heading">User account was not found.</h2>
                    <div className="messageBox">
                        <h3>Invalid email address.</h3>
                        <p>User account was not found, we suggest you try a different email address</p>
                        <button className="btn btn-lg btn-secondary btn-block" type="button" onClick={() => this.handleSubmit()}>Back to login</button>
                    </div>
                </div>
            }
            {this.props.ManageUsersState.Message == "email was sent" &&
                <div className="form-signin form-password form-wider">
                    <h2 className="form-signin-heading">Reset your password.</h2>
                    <div className="messageBox">
                        <h3>We have sent a reset password email to <b>{this.state.Email}</b>. Please click the reset password link to set your new password.</h3>
                        <p>Didn't receive email yet? Please email IRIS support<br />IRIS-info@umich.edu or call 734-615-0015.</p>
                    </div>
                </div>
            }
        </div>;
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            sendPasswordResetEmail: sendPasswordResetEmail,
            logout: logout
        }, dispatch
    )
}

const mapStateToProps = (state: ApplicationState) => ({
    UserState: state.userProperties,
    ManageUsersState: state.manageUsersProperties
});

const PasswordResetForm = styled.div`
    display: grid;
    grid-gap: 1.5rem;
    min-height: 420px;
    max-width: 420px;
    padding: 25px;
    margin: 0 auto;
    margin-top: 60%;
    background-color: #fff;
`;

export default connect(
    mapStateToProps,
    matchDispatchToProps
)(ForgotPassword);
